import clsx from 'clsx'
import Link from 'next/link'

import { useBooleanState } from '@/shared/lib/hooks/useBooleanState'
import { Button } from '@/shared/ui'

import cl from './style.module.scss'

export interface CatListExtraItem {
	NAME: string
	LINK: string
}

export const CatListExtra = (props: { items: CatListExtraItem[] }) => {
	const { enable, active, disable } = useBooleanState()
	const { items = [] } = props

	if (items.length < 1) return null
	return (
		<div className={cl.root}>
			<Button theme={'link'} onClick={enable} className={clsx(cl.btn, { [cl.btn_hidden]: active })}>
				Показать еще
			</Button>

			<div className={clsx(cl.content, { [cl.content_hidden]: !active })}>
				{items.map(item => (
					<li key={item.NAME} className={cl.item}>
						<Link prefetch={false} href={item.LINK} className={cl.link}>
							{item.NAME}
						</Link>
					</li>
				))}
			</div>
			<Button theme={'link'} onClick={disable} className={clsx(cl.btn, { [cl.btn_hidden]: !active }, cl.btn_pt)}>
				Скрыть
			</Button>
		</div>
	)
}
